import React, { useState, useContext, useEffect } from "react";
import Application from "../../../StateContext/Application";
import { usePDF } from 'react-to-pdf';
import { CSVLink } from "react-csv";
const ClosedTenders = () => {
    const statecalls = useContext(Application);
    const { GetClosedTenders } = statecalls;
    const [displaytenders, setDisplayTenders] = useState([])
    const [searchdate, setSearchDate] = useState({})
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [CSVDATA, SetCSVDATA] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = displaytenders?.slice(indexOfFirstItem, indexOfLastItem);
    var csv = [
        ["Tender Name", "PO Number", "Description", "Tender Opening Date", "Tender Closing Date", "GST", "Ernest Money Deposit", "Tender Fee", "Registrations"]
    ]


    async function ShowClosedTenders(e) {
        try {
            e.preventDefault()
            let data = await GetClosedTenders(searchdate)
            setDisplayTenders(data)
        } catch (error) {
            console.error(error)
        }
    }
    function SaveCSV() {
        try {
            displaytenders.forEach((x) => {
                csv.push([x.Tender_Name, x.PO_Number, x.Description, x.Tender_Opening_Date, x.Tender_Closing_Date, x.GST, x.ErnestMoneyDeposit, x.TenderFee, x.registertion_count])
            })
            SetCSVDATA(csv);
        } catch (error) {
            console.error('Error saving file:', error);
        }
    }
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div style={{ backgroundColor: "#f6f8fc", padding: "50px" }}>
                <CSVLink data={CSVDATA} target="blank" onClick={SaveCSV} className='my-3 btn btn-primary'> Download Excel</CSVLink>
                <button onClick={() => { toPDF() }} className='my-3 mx-2 btn btn-success' >Download PDF</button>
                <div style={{ display: "grid", border: "2px solid red", borderRadius: "20px", border: "none", padding: "20px", backgroundColor: 'white' }}>

                    <div style={{ display: 'grid' }}>
                        <div>
                            <label className='heading'>Search Tenders by Date</label>
                            <form onSubmit={ShowClosedTenders} style={{ width: '70vw' }} className='my-3'>
                                <label className="form-label">Tender Opening Date</label>
                                <input className='mb-3 form-control ' style={{ display: "flex", justifyContent: "center" }} type='date' id="TenderOpeningDate" onChange={(e) => setSearchDate({ ...searchdate, [e.currentTarget.id]: e.target.value })} />
                                <label className="form-label">Tender Closing Date</label>
                                <input className='mb-3 form-control ' style={{ display: "flex", justifyContent: "center" }} type='date' id="TenderClosingDate" onChange={(e) => setSearchDate({ ...searchdate, [e.currentTarget.id]: e.target.value })} />
                                <button type="submit" className="btn btn-primary" style={{ backgroundColor: "#e73d26", border: "none" }}>Search</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ padding: "50px" }}>
                <table className="table table-bordered" ref={targetRef}>
                    <thead>
                        <tr>
                            <th>Sr.no.</th>
                            <th>Tender Name</th>
                            <th>PO Number</th>
                            <th>Description</th>
                            <th>Tender Opening Date</th>
                            <th>Tender Closing Date</th>
                            <th>GST</th>
                            <th>Ernest Money Deposite</th>
                            <th>Tender Fee</th>
                            <th>Registrations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            displaytenders && currentItems.map((e,index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{e.Tender_Name}</td>
                                        <td>{e.PO_Number}</td>
                                        <td>{e.Description}</td>
                                        <td>{e.Tender_Opening_Date}</td>
                                        <td>{e.Tender_Closing_Date}</td>
                                        <td>{e.GST}</td>
                                        <td>{e.ErnestMoneyDeposit}</td>
                                        <td>{e.TenderFee}</td>
                                        <td>{e.registertion_count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(displaytenders.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
                </div>

            </div>
        </>
    )
}

export default ClosedTenders;